import { getAppConfig } from "@/api/apps";
import { genActiveRule } from "@/utils/index";
import { isExternal } from "@/utils/validate";
import { downloadTracking } from "@/utils/helper";
import {
  registerMicroApps, // 注册子应用方法
  // setDefaultMountApp, // 设默认启用的子应用
  // runAfterFirstMounted, // 有个子应用加载完毕回调
  start, // 启动qiankun
  addGlobalUncaughtErrorHandler, // 添加全局未捕获异常处理器
  initGlobalState, // 官方应用间通信
} from "qiankun";
import moment from "moment";
import i18n from "../lang";
import store from "../store";
import { resetRouter } from "../router";
import { render } from "./render";
import mapper from "./mapper";

// 导入应用间通信介质：呼机
const msg = {
  state: {
    ...store.getters, // 从主应用仓库读出的数据
    time: moment().format("yyyy.MM.DD HH:mm:ss"),
    tracking: ({ downloadApi, ...rest }) => {
      const path = window.location.pathname;
      downloadTracking(path, {
        downloadApi,
        downloadName: downloadApi ? mapper[downloadApi] : undefined,
        ...rest,
        url: path,
      });
    },
  }, // 便于展示官方通信示例的临时数据
};

// 在主应用注册官方通信方案
const actions = initGlobalState(msg.state);
// 注册消息监听函数
actions.onGlobalStateChange((state, prevState) => {
  // console.log("主应用监听中", state, prevState);
  if (
    state.token !== prevState.token ||
    state.language !== prevState.language
  ) {
    i18n.locale = state.language;
    store.dispatch("app/toggleLanguage", state.language);
    getMircoApps();
  }
});

function appendAppHost(param) {
  const data = [];
  if (param && param.length) {
    param.forEach((menu) => {
      if (!isExternal(menu.path)) {
        const [p, port = ""] = (menu.path && menu.path.split(":")) || [
          menu.path,
          "",
        ];
        let path = p;
        if (p && port) {
          path = p.split("/").slice(0, 2).join("/");
        }
        // if (port === "") return;
        if (data.find((item) => item.path === path)) return;
        data.push({
          ...menu,
          path,
          host: `//localhost:${port}`,
        });
      } else if (menu.path) {
        data.push(menu);
      }
    });
    data.push({
      id: "999",
      key: "999",
      title: "公共报告",
      icon: null,
      path: "/baogao",
      host: `//localhost:8122`,
      type: 0,
      children: [],
    });
    return data.filter((item) => item.path);
  }
}

export async function getMircoApps() {
  return await getAppConfig().then(({ data } = { data: {} }) => {
    if (!data || !data.data) return;
    if (data.status.status === 0) {
      const _res = appendAppHost(data.data || []) || [];
      const modules = _res.map((item) => ({
        path: item.path,
        title: item.title,
        id: item.id,
      }));
      // console.log(
      //   "getMircoApps",
      //   _res,
      //   _res.map(item => `${item.host}${item.path}`)
      // );
      // 处理合法路由
      store.dispatch("user/setRoutes", _res);
      resetRouter();
      // 处理子应用注册数据
      const apps = [];
      // let defaultApp = null;
      _res &&
        _res
          .filter((item) => item.host)
          .forEach((item) => {
            // 特殊商圈转跳
            const path = item.path === "/sq" ? "/channel" : item.path;
            // 车型速览不用注册
            if (path === "/model-fastview") return;
            apps.push({
              name: item.path,
              entry:
                process.env.NODE_ENV === "development"
                  ? `${item.host}${path}/`
                  : `${path}/`,
              render,
              activeRule: genActiveRule(item.path),
              props: {
                state: {
                  ...store.getters, // 从主应用仓库读出的数据
                  time: moment().format("yyyy.MM.DD HH:mm:ss"),
                },
                ROUTES: item.children,
                path: item.path,
                routerBase: path,
                modules,
              },
            });
            // if (i.defaultRegister) defaultApp = i.path;
          });
      // 注册子应用
      registerMicroApps(apps, {
        beforeLoad: [
          (app) => {
            console.log("before load", app);
          },
        ],
        beforeMount: [
          (app) => {
            app.props = {
              ...app.props,
              state: {
                ...store.getters,
                time: moment().format("yyyy.MM.DD HH:mm:ss"),
              },
            };
            console.log("before mount", app);
          },
        ],
        afterUnmount: [
          (app) => {
            console.log("after unload", app);
          },
        ],
      });
      // 设置默认子应用
      // if (!defaultApp) defaultApp = _res[0].path;
      // setDefaultMountApp(defaultApp);
      // // 第一个子应用加载完毕回调
      // runAfterFirstMounted((app) => {
      //   console.log(app);
      // });
      // 启动微服务
      start({
        prefetch: false,
        sandbox: true,
        excludeAssetFilter: (assetUrl) => {
          const whiteList = [];
          const whiteWords = ["baidu", "meiqia"];
          if (whiteList.includes(assetUrl)) {
            return true;
          }
          return whiteWords.some((w) => {
            return assetUrl.includes(w);
          });
        },
      });
      // 设置全局未捕获一场处理器
      addGlobalUncaughtErrorHandler((event) => {
        console.log(event);
        // if (event && event.error) {
        //   IwaysUI.Notification({
        //     type: "error",
        //     title: "异常错误",
        //     message: "项目启动异常，即将转跳回主页",
        //     duration: 5000,
        //     onClose() {
        //       router.push("/dashboard");
        //     }
        //   });
        // }
      });
      return _res;
    }
  });
}
